import { withInstall } from '@pit-element-plus/utils'
import DialogHeader from './src/dialog-header.vue'

export const ElDialogHeader = withInstall(DialogHeader)
export default ElDialogHeader

export * from './src/use-dialog-header'
export * from './src/dialog-header'
export * from './src/constants'
